import React from 'react';
import { Link } from 'react-router-dom';
import './DemoBanner.css';

const DemoBanner = () => {
  return (
    <div className="demo-banner">
      <div className="demo-banner-content">
        <div className="demo-banner-text">
          <span className="demo-badge">DEMO</span>
        </div>
        <Link to="/map" className="demo-banner-login-btn">
          Log in to connect your own SharePoint
        </Link>
      </div>
    </div>
  );
};

export default DemoBanner;